import React from 'react';
import { useLocation } from 'react-router-dom';
import { LANGUAGE, URL_PREFIX } from '../constants/global';
import i18n from '../i18n';

export default function Localization(props) {
  const location = useLocation();

  React.useEffect(() => {
    const lang = location.pathname.includes(URL_PREFIX.FR)
      ? LANGUAGE.FR
      : LANGUAGE.EN;

    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
      document.documentElement.lang = lang;
    }
  }, [location]);

  return props.children;
}
